// extracted by mini-css-extract-plugin
export default {"reviews":"styles_reviews__xD1wq","reviews__list":"styles_reviews__list__FsIR7"};